// extracted by mini-css-extract-plugin
export default {"wrapper":"header_doctrine_logo-module__wrapper--18bgQ","hide":"header_doctrine_logo-module__hide--cbCcl"};